import { memo } from "react"
import { Link } from "react-router-dom"
import { noop } from "lodash"
import type { PortfolioNavExpandedLink } from "../../navigation"
import SubLink from "./sublink"

export interface MobileNavLinkGroupProps {
  link: PortfolioNavExpandedLink
  onSaveLastLocation?: (id: string) => void
}

const MobileNavLinkGroup = memo(function MobileNavLinkGroup({ link, onSaveLastLocation = noop }: MobileNavLinkGroupProps) {
  const IconComponent = link.Icon

  function handleClick() {
    onSaveLastLocation(link.id)
  }

  return <div className="group">
    <Link onClick={link.openInNewTab ? undefined : handleClick} to={link.to} className="mobile-link" {...(link.openInNewTab ? { target: "_blank", rel: "noreferrer noopener" } : {})}>
      {IconComponent
        ? <IconComponent className="icon nav-link-mui-icon" fontSize="small" />
        : <i className={`icon fa fa-${link.icon}`} />}
      <div className="label">{link.label}</div>
    </Link>
    {(link.subItems ?? [])
      .filter(subLink => !subLink.hidden)
      .map(subLink =>
        <SubLink id={subLink.id} parentId={link.id} key={subLink.id} to={subLink.to} label={subLink.label} />,
      )}
  </div>
})

export default MobileNavLinkGroup
